import Vue from 'vue'
import store from '@/store'
import { isInRenewOrderDate, isInRenewOaChatDate, isUpdatedProfile, isInRenewPremiumIdDate } from '@/utils/order.util'

export default async (to, from, next) => {
  const vm = new Vue()

  const renewText = 'ต่ออายุ'
  const broadcastPackage = 'แพ็กเกจบรอดแคสต์'
  const oaChatPackage = ' OA Chat Package '
  const premiumIdPackage = ' Premium ID '

  const newTitle = (word) => `ปัจจุบันคุณมี${word}อยู่แล้ว`
  const newRenewMessage = (word) => `คุณสามารถซื้อบริการ${word}ล่วงหน้าได้แล้ว<br>หากคุณต้องการต่ออายุ กรุณากดปุ่ม "${renewText}"`
  const newExistMessage = (word) => `เนื่องจากตอนนี้เปิดใช้บริการ${word}อยู่<br>คุณยังไม่สามารถซื้อบริการล่วงหน้าได้ในขณะนี้`

  const activeLineOfficialAccount = store.getters['User/activeLineOfficialAccount']
  const MAXIMUM_PERIOD_PRE_ORDER = store.getters['SystemConfig/GET_MAXIMUM_PERIOD_PRE_ORDER']

  const isFreePackagePlan = activeLineOfficialAccount.packagePlan === 'free'

  const isRenew = !!to.query.isRenew

  const isBuyPackage = to.params.productType === 'package'
  const isBuyMessage = to.params.productType === 'message'
  const isBuyOaChat = to.params.productType === 'oaChat'
  const isBuyPremiumId = to.params.productType === 'premiumId'
  const isNewLineOfficialAccount = to.params.productType === 'newLineOfficialAccount'

  if (to.name === 'OrderCreate') {
    if (!isNewLineOfficialAccount && !isUpdatedProfile(activeLineOfficialAccount)) {
      if (to.query.affiliateKey) {
        next({ name: 'LineOfficialAccountCreate' })
      } else {
        await vm.$swal({
          icon: 'warning',
          title: 'ข้อมูล Basic ID ยังไม่ถูกอัพเดท',
          html: 'กรุณาอัพเดทข้อมูล Basic ID ของท่านก่อนทำรายการ',
          confirmButtonText: 'อัพเดทข้อมูล Basic ID'
        })
        next({ name: 'ProfileEdit' })
      }
    } else if (isBuyPackage) {
      let isAllowToBuyPackage = false
      if (
        (isRenew || !isFreePackagePlan)
        && !isInRenewOrderDate(activeLineOfficialAccount, MAXIMUM_PERIOD_PRE_ORDER)
      ) {
        await vm.$swal({
          icon: 'warning',
          title: newTitle(broadcastPackage),
          html: newExistMessage(broadcastPackage)
        })
      } else if (
        from.name !== 'OrderSummary'
        && !isRenew
        && isInRenewOrderDate(activeLineOfficialAccount, MAXIMUM_PERIOD_PRE_ORDER)
      ) {
        const res = await vm.$swal({
          icon: 'warning',
          title: newTitle(broadcastPackage),
          html: newRenewMessage(broadcastPackage),
          confirmButtonText: renewText
        })
        if (res.isConfirmed) {
          next({ name: 'OrderCreate', params: { productType: 'package' }, query: { isRenew: true } })
        }
      } else {
        isAllowToBuyPackage = true
      }

      if (isAllowToBuyPackage) {
        next()
      } else if (!isAllowToBuyPackage && (from.name == null || from.name === 'LineOfficialAccountChoose')) {
        next({ name: 'Home' })
      }
    } else if (isBuyOaChat) {
      let isAllowToBuyOaChat = false
      const hasOaChat = activeLineOfficialAccount.oaChatExpiredAt != null
      if (!isRenew && isInRenewOaChatDate(activeLineOfficialAccount, MAXIMUM_PERIOD_PRE_ORDER)) {
        const res = await vm.$swal({
          icon: 'warning',
          title: newTitle(oaChatPackage),
          html: newRenewMessage(oaChatPackage),
          confirmButtonText: renewText
        })
        if (res.isConfirmed) {
          next({ name: 'OrderCreate', params: { productType: 'oaChat' }, query: { isRenew: true } })
        }
      } else if (!isRenew && hasOaChat) {
        await vm.$swal({
          icon: 'warning',
          title: newTitle(oaChatPackage),
          html: newExistMessage(oaChatPackage)
        })
      } else {
        isAllowToBuyOaChat = true
      }

      if (isAllowToBuyOaChat) {
        next()
      } else if (!isAllowToBuyOaChat && (from.name == null || from.name === 'LineOfficialAccountChoose')) {
        next({ name: 'Home' })
      }
    } else if (isBuyPremiumId) {
      let isAllowToBuyPremiumId = false
      const hasPremiumId = activeLineOfficialAccount.premiumIdExpiredAt != null
      if (!isRenew && isInRenewPremiumIdDate(activeLineOfficialAccount, MAXIMUM_PERIOD_PRE_ORDER)) {
        const res = await vm.$swal({
          icon: 'warning',
          title: newTitle(premiumIdPackage),
          html: newRenewMessage(premiumIdPackage),
          confirmButtonText: renewText,
          width: '33em'
        })
        if (res.isConfirmed) {
          next({ name: 'OrderCreate', params: { productType: 'premiumId' }, query: { isRenew: true } })
        }
      } else if (!isRenew && hasPremiumId) {
        await vm.$swal({
          icon: 'warning',
          title: newTitle(premiumIdPackage),
          html: newExistMessage(premiumIdPackage),
          width: '33em'
        })
      } else {
        isAllowToBuyPremiumId = true
      }

      if (isAllowToBuyPremiumId) {
        next()
      } else if (!isAllowToBuyPremiumId && (from.name == null || from.name === 'LineOfficialAccountChoose')) {
        next({ name: 'Home' })
      }
    } else if (isBuyMessage && isFreePackagePlan) {
      vm.$swal({
        icon: 'warning',
        title: 'ไม่สามารถซื้อได้',
        html: 'คุณต้องมีแพ็กเกจเป็น <b>Basic</b> หรือ <b>Pro</b> ก่อนจึงจะสามารถซื้อ Message เพิ่มได้'
      })
    } else {
      next()
    }
  } else {
    next()
  }
}
